$('.slider__main').slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        infinite: false,
        dots: false,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        infinite: false,
        dots: false,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
$('.image-text-popup-btn a.now-more').click(function(e){
  e.preventDefault()
  
       $('.image-text-popup-col').show()                                    
 $('.image-text-popup-section').removeClass(' hidedesktop hidembile') 
})
$('.slider__main').on('beforeChange', function(event, slick, currentSlide) {
  setTimeout(function(){
    

   if ($(window).width() < 767)
    {
      $('.item__video').addClass('ply')
  
 $('.item__video video').trigger('pause'); 
      $('.slider__main .item.slick-slide.slick-current.slick-active .item__video').removeClass('ply')
$('.slider__main .item.slick-slide.slick-current.slick-active video').trigger('play'); 
    }
      },200)
});
getpercentage();
    setTimeout(function(){
    
    getpercentage();
    
    },1000)
    
       setTimeout(function(){
    
     var grtht= $('body.template-product form.product-single__form').height();
         var neheigh=grtht+54;
         console.log('before'+grtht);
//        $('body.template-product form.product-single__form').css('height',neheigh+'px');
            var distance = $('.product__description.rte.quick-add-hidden').offset().top,
    $window = $(window);
         
        
         
         

$window.scroll(function() {
 
  
   var scrollTop     = $(window).scrollTop(),
    elementOffset = $('.product__description.rte.quick-add-hidden').offset().top,
    distancesnew      = (elementOffset - scrollTop);
  
  
  
  
    if ( distancesnew < 0 ) {
       setTimeout(function(){
        $('.template-product').addClass('sticky_form');
    
       },500)
       console.log(distancesnew+'ttop'+$window.scrollTop());
    }else{
     setTimeout(function(){
      $('.template-product').removeClass('sticky_form');
     },500)
       console.log(distancesnew+'ttop'+$window.scrollTop());
    }
});
    
    },2000)
       
       
    function getpercentage(){
     var gtpc=$('span.product__price.product__price--compare').attr('pprice');
      if(gtpc>1){
        $('.discountSave').show();
      }else{
         $('.discountSave').hide(); 
      }
  var pprices=$('span.product__price.product__price--compare').attr('pprice');
    var pprice=$('span.privSizelp.product__price.sale-price').attr('pprice');
    var newpice=pprice*100/pprices;
      var priget=100-newpice;
     var prigeting= priget.toFixed(0)
      $('span.dscntrate').text(prigeting+'% Off');
      
    }
     if($('body').hasClass('template-product')){
       var lblname=$('.variant-wrapper.variant-wrapper--button.js label.variant__label').text();
       var sltdTxt=$('.variant-input-wrap input[type=radio]:checked').next('label').text();
       
       $('.staticVariations .varName').text(lblname);
         $('.staticVariations .variationDetails').text(sltdTxt);
       
       
       
 
       
       
       
//        $(".variationData").click(function() {
//     $('html, body').animate({
//         scrollTop: $('#addscroll').offset().top
//     }, 800);
// });
       $('.fxed button').click(function(){
         $('.fxed button').text('Adding...');
       $('.template-product .product-form__submit').trigger('click');
        $('html, body').animate({
        scrollTop: $("fieldset.product-form__input").offset().top 
    }, 300);
         setTimeout(function(){
         $('.fxed button').text('Add to cart');
         },2000)
       })
       
       setTimeout(function(){
       
       
       
       var pprices=$('span.product__price.product__price--compare').attr('pprice');
    var pprice=$('span.privSizelp.product__price.sale-price').attr('pprice');
    var newpice=pprice*100/pprices;
      var priget=100-newpice;
     var prigeting= priget.toFixed(0) 
       var sltdTxt=$('.variant-input-wrap input[type=radio]:checked').next('label').text();
       
         $('.staticVariations .variationDetails').text(sltdTxt);
      $('span.dscntrate').text(prigeting+'% Off');
              if(prigeting=='NaN'){
              $('span.privSizelp.discountSave').hide();
              }else{
                $('span.privSizelp.discountSave').show();
              }
            
         
       },1000)
     }

    $('.faq-section-inner ul li').click(function(){
      if($(this).hasClass('active')){
         $('.faq-section-inner ul li').removeClass('active');
      $('.faq-section-inner ul li .faq-ans').slideUp();
      }else{


         $('.faq-section-inner ul li').removeClass('active');
      $('.faq-section-inner ul li .faq-ans').slideUp();
      $(this).find('.faq-ans').slideDown();
        $(this).addClass('active');


        
      }
     
    })



$('.close--drawer svg').click(function(){
  $('.menu-drawer-container.menu-opening summary.header__icon')[0].click();
})
$('.template-product .product-form__input label').click(function(){
 var gps= $(this).prev('input').val();

  var ofer=$('select#all_pdfrop option[tle="'+gps+'"]').attr('ofer')
  var price=$('select#all_pdfrop option[tle="'+gps+'"]').attr('price')
  $('span.privSizelp.product__price.sale-price').text(price)
  $('span.product__price.product__price--compare').text(ofer)
  
 
  if(ofer != ''   ){
  
     if(typeof ofer === 'undefined' ){

    $('span.privSizelp.product__price').text(price)
       $('span.privSizelp.discountSave').hide();
    $('span.privSizelp.product__price-wrap-').hide()
       
     }else{
  $('span.privSizelp.product__price-wrap-').show()
       $('span.privSizelp.discountSave').show();
      var pprices=Number($('select#all_pdfrop option[tle="'+gps+'"]').attr('sprice'));
        var sofer=Number($('select#all_pdfrop option[tle="'+gps+'"]').attr('sofer'));
            
    // var pprice=Number($(data).find('span.ofrtrext+span+span.privSizelp.product__price.sale-price').attr('pprice'));
                
    var newpice=pprices*100/sofer;
      var priget=100-newpice;
     var prigeting= priget.toFixed(0) 
       
     $('span.dscntrate').text(prigeting+'% Off');
     }
  }else{

    

    
       $('span.privSizelp.discountSave').hide();
    $('span.privSizelp.product__price-wrap-').hide()
 
  }

  
})

$('.template-product .product-form__input input[type=radio]').change(function(){
  //   detectprice()

  // setTimeout(function(){
  //   detectprice()
  //  },800)
  // setTimeout(function(){
  //   detectprice()
  //  },1000)
  //  setTimeout(function(){
  //   detectprice()
  //  },500)
})

function detectprice(){
  var seprice= $('s.price-item.price-item--regular').text();
    $('body.template-product span.product__price.product__price--compare').text(seprice);
    var origin= $('span.price-item.price-item--sale.price-item--last').text();
    $('span.ofrtrext+span+span.privSizelp.product__price.sale-price').text(origin)
   


    


     setTimeout(function(){
            var sd=window.location.href; 
                jQuery.ajax({
            url:sd,
            type:'GET',
            success:function(data){
            
              
      var pprices=Number($(data).find('span.product__price.product__price--compare').attr('pprice'));
            
    var pprice=Number($(data).find('span.ofrtrext+span+span.privSizelp.product__price.sale-price').attr('pprice'));
                
    var newpice=pprice*100/pprices;
      var priget=100-newpice;
     var prigeting= priget.toFixed(0) 
              console.log(pprices+'--'+sd+'????'+pprice)
       // var sltdTxt=$('.variant-input-wrap input[type=radio]:checked').next('label').text();
       
       //   $('.staticVariations .variationDetails').text(sltdTxt);
      $('span.dscntrate').text(prigeting+'% Off');
              if(prigeting=='NaN'){
              $('span.privSizelp.discountSave').hide();
              }else{
                $('span.privSizelp.discountSave').show();
              }
            } 
        });
          },10)

    


    
  
}

if($('body').hasClass('template-product')){
 setTimeout(function(){
   if($('fieldset.product-form__input').length){
  $('.variationData').click(function(){
      $('html, body').animate({
        scrollTop: $("fieldset.product-form__input").offset().top 
    }, 300);
  })
   }
 
            },2000)
  setTimeout(function(){
    
  var slct=$('.template-product .product-form__input input[type=radio]:checked').val().split(' (');
      
    $('.variationData').text(slct[0])
  },1000)
  $('.product-form__input input[type=radio]').change(function(){
      setTimeout(function(){
    
  var slct=$('.template-product .product-form__input input[type=radio]:checked').val().split(' (');
      
   $('.variationData').text(slct[0])
  },300)
  })

}

 $('header-menu>details').mouseenter(function(){
  $(this).attr('open','open')
 })
$('header-menu>details').mouseleave(function(){
   $(this).removeAttr('open')
 })
if($('body').hasClass('template-product')){

 
  $('.product .rating-star').css('--rating-decimal','.5')
 $('label[lp="2"]').trigger('click') 
  var vd=$('select#all_pdfrop option:nth-child(2)').attr('vd')
$('input.product-variant-id').val(vd)
}
